export const LENGTH = {
    SINGLE_LINE: 255,
    MULTI_LINE: 5000,
    NUMBER: 10,
}